export type ParamsValueType = (string | number)[] | string | number | boolean;
const INITIAL_QUERY = '?';
export const prepareQueryParams = (params: Record<string, ParamsValueType | undefined>) => {
  let query = INITIAL_QUERY;

  Object.entries(params).forEach(([key, value]: [string, ParamsValueType | undefined]) => {
    const joiner = query === INITIAL_QUERY ? '' : '&';

    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      query += `${joiner}${key}=${encodeURIComponent(String(value))}`;
    }
    if (Array.isArray(value) && value.length) {
      query += `${joiner}${key}=${value.join(`&${key}=`)}`;
    }
  });

  return query;
};
